/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormOption } from './FormOption';
import {
    FormOptionFromJSON,
    FormOptionFromJSONTyped,
    FormOptionToJSON,
    FormOptionToJSONTyped,
} from './FormOption';

/**
 * 
 * @export
 * @interface MedicareAssessmentFormOptions
 */
export interface MedicareAssessmentFormOptions {
    /**
     * 
     */
    primary_diagnosis: Array<FormOption>;
    /**
     * 
     */
    slp_related_comorbidities: Array<FormOption>;
    /**
     * 
     */
    cognitive_level_assessment_daily_decision_making: Array<FormOption>;
    /**
     * 
     */
    cognitive_level_assessment_makes_self_understood: Array<FormOption>;
    /**
     * 
     */
    conditions_services: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_extensive_services: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_special_care_high: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_special_care_low: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_clinically_complex: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_other_symptoms: Array<FormOption>;
    /**
     * 
     */
    nursing_assessment_services_required: Array<FormOption>;
}

/**
 * Check if a given object implements the MedicareAssessmentFormOptions interface.
 */
export function instanceOfMedicareAssessmentFormOptions(value: object): value is MedicareAssessmentFormOptions {
    if (!('primary_diagnosis' in value) || value['primary_diagnosis'] === undefined) return false;
    if (!('slp_related_comorbidities' in value) || value['slp_related_comorbidities'] === undefined) return false;
    if (!('cognitive_level_assessment_daily_decision_making' in value) || value['cognitive_level_assessment_daily_decision_making'] === undefined) return false;
    if (!('cognitive_level_assessment_makes_self_understood' in value) || value['cognitive_level_assessment_makes_self_understood'] === undefined) return false;
    if (!('conditions_services' in value) || value['conditions_services'] === undefined) return false;
    if (!('nursing_assessment_extensive_services' in value) || value['nursing_assessment_extensive_services'] === undefined) return false;
    if (!('nursing_assessment_special_care_high' in value) || value['nursing_assessment_special_care_high'] === undefined) return false;
    if (!('nursing_assessment_special_care_low' in value) || value['nursing_assessment_special_care_low'] === undefined) return false;
    if (!('nursing_assessment_clinically_complex' in value) || value['nursing_assessment_clinically_complex'] === undefined) return false;
    if (!('nursing_assessment_other_symptoms' in value) || value['nursing_assessment_other_symptoms'] === undefined) return false;
    if (!('nursing_assessment_services_required' in value) || value['nursing_assessment_services_required'] === undefined) return false;
    return true;
}

export function MedicareAssessmentFormOptionsFromJSON(json: any): MedicareAssessmentFormOptions {
    return MedicareAssessmentFormOptionsFromJSONTyped(json, false);
}

export function MedicareAssessmentFormOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MedicareAssessmentFormOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'primary_diagnosis': ((json['primary_diagnosis'] as Array<any>).map(FormOptionFromJSON)),
        'slp_related_comorbidities': ((json['slp_related_comorbidities'] as Array<any>).map(FormOptionFromJSON)),
        'cognitive_level_assessment_daily_decision_making': ((json['cognitive_level_assessment_daily_decision_making'] as Array<any>).map(FormOptionFromJSON)),
        'cognitive_level_assessment_makes_self_understood': ((json['cognitive_level_assessment_makes_self_understood'] as Array<any>).map(FormOptionFromJSON)),
        'conditions_services': ((json['conditions_services'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_extensive_services': ((json['nursing_assessment_extensive_services'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_special_care_high': ((json['nursing_assessment_special_care_high'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_special_care_low': ((json['nursing_assessment_special_care_low'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_clinically_complex': ((json['nursing_assessment_clinically_complex'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_other_symptoms': ((json['nursing_assessment_other_symptoms'] as Array<any>).map(FormOptionFromJSON)),
        'nursing_assessment_services_required': ((json['nursing_assessment_services_required'] as Array<any>).map(FormOptionFromJSON)),
    };
}

export function MedicareAssessmentFormOptionsToJSON(json: any): MedicareAssessmentFormOptions {
    return MedicareAssessmentFormOptionsToJSONTyped(json, false);
}

export function MedicareAssessmentFormOptionsToJSONTyped(value?: MedicareAssessmentFormOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'primary_diagnosis': ((value['primary_diagnosis'] as Array<any>).map(FormOptionToJSON)),
        'slp_related_comorbidities': ((value['slp_related_comorbidities'] as Array<any>).map(FormOptionToJSON)),
        'cognitive_level_assessment_daily_decision_making': ((value['cognitive_level_assessment_daily_decision_making'] as Array<any>).map(FormOptionToJSON)),
        'cognitive_level_assessment_makes_self_understood': ((value['cognitive_level_assessment_makes_self_understood'] as Array<any>).map(FormOptionToJSON)),
        'conditions_services': ((value['conditions_services'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_extensive_services': ((value['nursing_assessment_extensive_services'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_special_care_high': ((value['nursing_assessment_special_care_high'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_special_care_low': ((value['nursing_assessment_special_care_low'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_clinically_complex': ((value['nursing_assessment_clinically_complex'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_other_symptoms': ((value['nursing_assessment_other_symptoms'] as Array<any>).map(FormOptionToJSON)),
        'nursing_assessment_services_required': ((value['nursing_assessment_services_required'] as Array<any>).map(FormOptionToJSON)),
    };
}

